
<template>
  <v-container fill-height
               grid-list-xl>
    <v-layout justify-center
              wrap>
      <v-flex xs12 md10>
        <material-card :color="getTitleColorStore"
                       :title="$t('menu_education_deadline')"
                       :text="$t('program_deadline.subtitle')">
          <ProgressBar :loading="loading" color="deep-purple accent-4" />
          <template>
            <v-container grid-list-md fluid>
              <v-layout row justify-center>

                <v-flex xs12>
                  <SelectEducation :PopisUsluga="podaci" :odabir="setOdabranaUsluga" ref="myselect"></SelectEducation>
                </v-flex>
                <v-flex xs12>
                  <DeadlineTable :podaci="odabranaUsluga"></DeadlineTable>
                </v-flex>

                <v-flex xs12 md6>
                  <ExtensionsTable :produljenja="produljenja"></ExtensionsTable>
                </v-flex>
              </v-layout>
            </v-container>
          </template>

        </material-card>
      </v-flex>

    </v-layout>
  </v-container>

</template>

<script>
  import moment from 'moment';
  import { mapState, mapMutations, mapGetters } from 'vuex';
  import SelectEducation from './program_deadline_components/SelectEducation.vue';
  import DeadlineTable from './program_deadline_components/DeadlineTable.vue';
  import ExtensionsTable from './program_deadline_components/ExtensionsTable.vue';

  export default {
    name: 'ProgramDeadline',
    computed: {
      ...mapGetters('app', { getTitleColorStore: 'getTitleColor' }),
    },

    mounted() {
      this.ucitajPodatke();
    },

    data() {
      return {
        loading: false,
        podaci: [],
        odabranaUsluga: [], // Uvijek je jedna, ali �aljem u tablicu kao array
        produljenja: [],
      }
    },

    methods: {
      setOdabranaUsluga(item) {
        this.odabranaUsluga = [item];
        if (item.ProduljenjeViewModel.Produljenja.length > 0) {
          for (var i = 0; i < this.podaci.length; i++) {
            if (this.podaci[i].UpisPoId == item.UpisPoId) {
              this.produljenja = this.podaci[i].ProduljenjeViewModel.Produljenja
            }
          }
        } else {
          this.produljenja = [];
        }

      },

      async ucitajPodatke() {
        this.loading = true;
        var result = await this.$fetchDataPromise('/api/ProgramDeadline/GetPopisPrograma', null).catch(x => { this.loading = false; this.$displayErrorModal(x) });
        this.podaci = result;

        if (this.podaci && this.podaci.length > 0) {
          // Defaultni odabir
          this.$refs.myselect.odabranaUsluga = result[0];
          this.setOdabranaUsluga(result[0]);
        }

        this.loading = false;
      },


    },

    components: {
      SelectEducation, DeadlineTable, ExtensionsTable
    }

  }
</script>



// WEBPACK FOOTER //
// VueSrc/Education/ProgramDeadline.vue